module.exports = {"429005001":"园林","429005002":"杨市","429005003":"周矶","429005004":"广华","429005005":"泰丰","429005006":"高场","429005100":"竹根滩镇","429005101":"渔洋镇","429005102":"王场镇","429005103":"高石碑镇","429005104":"熊口镇","429005105":"老新镇","429005106":"浩口镇","429005107":"积玉口镇","429005108":"张金镇","429005109":"龙湾镇","429005400":"江汉石油管理局","429005401":"潜江经济开发区","429005450":"周矶管理区","429005451":"后湖管理区","429005452":"熊口管理区","429005453":"总口管理区","429005454":"白鹭湖管理区","429005455":"运粮湖管理区","429005457":"浩口原种场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/429005.json
// module id = 1801
// module chunks = 0